const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY

const baseURL = process.env.NODE_ENV === "production" ? "https://gosupply.com.au" : "http://127.0.0.1:8000"
const wsBaseURL = process.env.NODE_ENV === "production" ? "wss://gosupply.com.au" : "ws://127.0.0.1:8000"

export {
    GOOGLE_MAPS_API_KEY,
    baseURL,
    wsBaseURL
}